import clsx from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const customTwMerge = extendTailwindMerge({});

interface CnFunction {
  (...inputs: any[]): any;
}

export const cn: CnFunction = (...inputs) => {
  return customTwMerge(clsx(inputs));
};
